module.exports = __webpack_public_path__ + "static/bicicletaAmarilla-60f1a258f74e112bbe1af5644392783e.png";